module.exports = __webpack_public_path__ + "static/media/cimo_bg_menu2.7204ad86.jpg";